import { useParams, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { getCommentAutoReplies } from '@/services/api/comment-auto-replies';
import FlowBuilder from '@/pages/Meta/Flow/Builder/Builder';

export default function CommentAutoReplyBuilder() {
    const { ruleId } = useParams<{ ruleId: string }>();
    const navigate = useNavigate();

    const { data: rules = [], isLoading } = useQuery({
        queryKey: ['comment-auto-replies'],
        queryFn: getCommentAutoReplies,
    });

    const rule = rules.find(r => r.id === Number(ruleId));

    if (isLoading) {
        return (
            <div className="flex items-center justify-center h-screen">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500" />
            </div>
        );
    }

    if (!rule || !rule.funnel_id) {
        return (
            <div className="flex flex-col items-center justify-center h-screen gap-4">
                <p className="text-gray-500">Regra não encontrada ou sem flow configurado.</p>
                <button
                    onClick={() => navigate('/meta/comment-auto-replies')}
                    className="text-blue-500 hover:underline"
                >
                    Voltar
                </button>
            </div>
        );
    }

    return (
        <FlowBuilder
            builderMode="comment_auto_reply"
            externalFunnelId={rule.funnel_id}
            ruleData={rule}
            onBack={() => navigate('/meta/comment-auto-replies')}
        />
    );
}
